export default {
  SET_LOADING: 'SET-LOADING',
  SET_BADGE_TOTAL: 'SET_BADGE_TOTAL',
  SET_SITEMAP_INFO: 'SET_SITEMAP_INFO',
  SET_ITEM_MODEL: 'SET_ITEM_MODEL',
};
